import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, Card, Col, Container, Row, Spacer, Text } from "@nextui-org/react";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Link, Loading, Resume, ThemePicker } from "../components";
import { ResumePicker } from "../components/resume-picker";
import { DEFAULT_THEME, THEMES } from "../config";
import { useResumeDataContext } from "../context";
import { useEditor, useTheme } from "../hooks";
import { useResumeRouting } from "../routing";
import { Editor } from "../types";
import styles from "./interactive.module.less";
var editorMapping = {
  certifications: Editor.Certifications,
  "contact-info": Editor.ContactInfo,
  education: Editor.Education,
  highlights: Editor.Highlights,
  intro: Editor.Intro,
  skills: Editor.Skills,
  "work-experience": Editor.WorkExperience
};
export var Interactive = function Interactive() {
  var _theme$name;

  var _useResumeDataContext = useResumeDataContext(),
      discardDraftResume = _useResumeDataContext.discardDraftResume,
      draftResume = _useResumeDataContext.draftResume,
      hasDraft = _useResumeDataContext.hasDraft,
      loadResume = _useResumeDataContext.loadResume,
      isLoading = _useResumeDataContext.isLoading,
      isNewResume = _useResumeDataContext.isNewResume,
      newResume = _useResumeDataContext.newResume,
      resumeData = _useResumeDataContext.resume,
      resumes = _useResumeDataContext.resumeEntries,
      storeDraftResume = _useResumeDataContext.storeDraftResume,
      theme = _useResumeDataContext.theme,
      themes = _useResumeDataContext.themes;

  var navigate = useNavigate();

  var _useState = useState((_theme$name = theme === null || theme === void 0 ? void 0 : theme.name) !== null && _theme$name !== void 0 ? _theme$name : DEFAULT_THEME),
      _useState2 = _slicedToArray(_useState, 2),
      currentTheme = _useState2[0],
      setCurrentTheme = _useState2[1];

  var onThemeChange = useCallback(function (t) {
    setCurrentTheme(t);
  }, [setCurrentTheme]);
  useTheme(currentTheme, themes);

  var _useParams = useParams(),
      resumeId = _useParams.resumeId; // watch URL for changes


  useEffect(function () {
    if (!resumeId) return;
    if (resumeId === "new" || isNewResume) return;
    discardDraftResume();
  }, [discardDraftResume, isNewResume, loadResume, resumeId]);
  useResumeRouting();
  var onResumeChanged = useCallback(function (incomingResumeData) {
    storeDraftResume(_objectSpread(_objectSpread({}, resumeData), incomingResumeData));
  }, [resumeData, storeDraftResume]);

  var _useEditor = useEditor(hasDraft ? draftResume : resumeData, onResumeChanged),
      container = _useEditor.container,
      openEditor = _useEditor.openEditor;

  var onResumeChange = useCallback(function (resumeId) {
    if (hasDraft) {
      if (!confirm("Are you sure you want to discard unsaved changes?")) return false;
      discardDraftResume();
    }

    navigate("".concat(encodeURIComponent(resumeId)));
    return true;
  }, [discardDraftResume, hasDraft, navigate]);
  var onEditClick = useCallback(function (section) {
    var editor = editorMapping[section];
    openEditor(editor);
  }, [openEditor]);
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true
  }, /*#__PURE__*/React.createElement(Row, {
    gap: 1,
    className: styles.flexWrap
  }, /*#__PURE__*/React.createElement(Col, {
    className: styles.leftColumn
  }, /*#__PURE__*/React.createElement(Card, {
    color: "primary"
  }, /*#__PURE__*/React.createElement(Text, {
    size: 15,
    color: "white",
    css: {
      m: 0
    }
  }, "This is the interactive view for your resume.", " ", !resumeId && "Once it has been saved, you'll be able to view it in a new tab.", !!resumeId && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    to: "/presentation/".concat(encodeURIComponent(resumeId), "?theme=").concat(encodeURIComponent(currentTheme)),
    icon: true,
    newTab: true,
    color: "text"
  }, "Click here"), " ", "to open it in a new tab."))), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(ResumePicker, {
    defaultResume: resumeId,
    resumes: resumes !== null && resumes !== void 0 ? resumes : [],
    onResumeChange: onResumeChange
  }), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(ThemePicker, {
    themes: THEMES,
    defaultTheme: DEFAULT_THEME,
    onThemeChange: onThemeChange
  })), /*#__PURE__*/React.createElement(Col, {
    span: 9,
    className: styles.resume
  }, isLoading && /*#__PURE__*/React.createElement(Loading, null), !isLoading && /*#__PURE__*/React.createElement(Resume, {
    embedded: true,
    mode: "edit",
    resumeData: hasDraft ? draftResume : resumeData,
    noResume: /*#__PURE__*/React.createElement(Button, {
      onClick: newResume
    }, "Create one now"),
    onEditSection: onEditClick
  }))), container);
};